export default __webpack_public_path__ + "static/media/manual.9e43ecf6.svg";